import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import {
    booleanReturnOpSchema,
    stringArrayReturnOpSchema,
    stringReturnOpSchema,
} from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const singleChoiceElementSchema = baseElementSchema.extend({
    type: z.literal("singleChoice"),
    question: z.union([z.string(), stringReturnOpSchema]),
    options: z.union([
        stringArrayReturnOpSchema,
        z.array(z.union([z.string(), stringReturnOpSchema])),

        // Old schema. Don't use this anymore. We can now pass the array of strings directly.
        z.object({
            logicOp: stringArrayReturnOpSchema,
        }),
    ]),
    fillInTheBlank: z.union([z.boolean(), booleanReturnOpSchema]).optional(),
    fillInTheBlankPlaceholder: z
        .union([z.string(), stringReturnOpSchema])
        .optional(),
});
export const singleChoiceElementDataSchema = z.object({
    answer: z.string(),
});
export type SingleChoiceElement = z.infer<typeof singleChoiceElementSchema>;
export type SingleChoiceElementData = z.infer<
    typeof singleChoiceElementDataSchema
>;
